export const AddonType = {
  CRUNCH_PLUS: "CrunchPlus",
  PT: "PT"
};

class Addon {
  id;
  provider;
  mms_id;
  name;
  description;
  is_orderable;
  addon_type;
  price;
  addon_parameters;
  allow_card_update;

  constructor(props) {
    Object.assign(this, props);
    this.price = +this.price;
  }

  static fromArray(addons) {
    return addons.map(a => new Addon(a));
  }

  static compareTypes(type1, type2) {
    return type1 < type2 ? 1 : -1;
  }

  isCrunchPlus() {
    return this.addon_type === AddonType.CRUNCH_PLUS;
  }

  isPersonalTrainer() {
    return this.addon_type === AddonType.PT;
  }

  getTax() {
    return this.addon_parameters.hasOwnProperty('tax') ? +this.addon_parameters.tax : 0;
  }

  getTotalWithoutTax() {
    return (this.price * this.getQuantity());
  }

  getTotal() {
    return (this.price * this.getQuantity()) + this.getTax();
  }

  getQuantity() {
    return this.addon_parameters.hasOwnProperty('quantity') ? this.addon_parameters.quantity : 1;
  }

  getFirstDueDateFormatter() {
    const date = new Date();
    if (this.addon_type === AddonType.CRUNCH_PLUS) {
      const period_length = +this.addon_parameters.free_period_length;
      if (this.addon_parameters.free_period_type === 'month') {
        date.setMonth(date.getMonth() + period_length);
      } else {
        date.setDate(date.getDate() + period_length);
      }
    }
    return date.toLocaleDateString();
  }
}

export default Addon;